import { INTEGRATION_PROVIDERS } from '@vy/types';
import { withDefault } from '@vy/utils';
import { PlanInputForm } from '../CreatePlanPage/create-plan-page-components/CreatePlanForm/create-plan-form-types/plan-input-form';

export function buildParentAgreementSettings(planInput: PlanInputForm) {
  const fixedProducts = withDefault(planInput.fixedProducts, []);

  const subscriptionProduct = fixedProducts[0];

  if (!subscriptionProduct) {
    return undefined;
  }

  const productName = subscriptionProduct.variants?.[0]?.name || subscriptionProduct.name || '';
  const productDescription = subscriptionProduct.variants?.[0]?.description || subscriptionProduct.description || '';

  const integrationEntities = [];

  const netSuiteEntity = subscriptionProduct.integrationEntities?.find(
    (entity) => entity.integrationProvider === INTEGRATION_PROVIDERS.netSuite
  );
  if (netSuiteEntity) {
    integrationEntities.push(netSuiteEntity);
  }

  return {
    productName,
    productDescription,
    integrationEntities: integrationEntities.length > 0 ? integrationEntities : undefined,
  };
}
